const useEmptyMount = {
  install: function(Vue, options) {
    Vue.prototype.$emptyMount = function( hydrating) {
      const el = document.createElement('DIV');
      document.body.appendChild(el);
      const id = `application-${this._uid}`;
      el.setAttribute('id', id)
      return this.$mount(`#${id}`, hydrating);
    }
    Vue.prototype.$queryMount = function(query, hydrating) {
      const el = document.querySelector(query)
      if (el == null) {
        throw new Error('Ошибка монтировки приложения')
      }
      const mountEl = document.createElement('DIV');
      el.appendChild(mountEl);
      const id = `application-${this._uid}`;
      mountEl.setAttribute('id', id)
      return this.$mount(`#${id}`, hydrating);
    }
  }
};
const useUtil = {
  install: function(Vue, options) {
    Vue.prototype.$timeOut = function(delay = 300) {
      return new Promise((resolve) => {
        if (this.clearTimeout) {
          clearTimeout(this.clearTimeout)
        }
        this.clearTimeout = setTimeout(resolve, delay);
      })
    },
    Vue.prototype.$getObjectsFromUrl = function(url = '') {
      const params = Object.fromEntries( new URLSearchParams( new BX.Uri(url).getQuery() ).entries( ));
      const assign = function(obj, keyPath, value) {
        const lastKeyIndex = keyPath.length - 1;
        for (let i = 0; i < lastKeyIndex; ++i) {
          let key = keyPath[i];
          const isArray = /.*_arr$/.test(key)
          if (isArray) {
            key = key.replace(/_arr$/, '')
          }
          if (!(key in obj)) {
            obj[key] = isArray?[]:{}
          }
          obj = obj[key];
        }
        if (Array.isArray(obj)) {
          obj.push(decodeURIComponent(value))
        } else {
          obj[keyPath[lastKeyIndex]] = decodeURIComponent(value)
        }
      }

      for (const prop in params) {
        const structure = prop.split('[');
        if (structure.length > 1) {
          const levels = [];
          structure.forEach(function(item, i) {
            const key = item.replace(/[?[\]\\ ]/g, '');
            levels.push(key);
          });
          assign(params, levels, params[prop]);
          delete(params[prop]);
        }
      }
      return params;
    },

    Vue.prototype.$objectFlatten = function(object, prefix) {
      return Object.keys(object).reduce((carry, key) => {
        const pre = prefix ? prefix + `[${key+(Array.isArray(object[key])?'_arr':'')}]` : '';
        if (Array.isArray(object[key])) {
          carry = object[key].reduce((array, value, index) => {
            array[(pre || key) + `[${index}]`] = value;
            return array;
          }, carry);
        } else if (object[key] && typeof object[key] === 'object') {
          Object.assign(carry, this.$objectFlatten(object[key], pre || key));
        } else if (object[key] != null && object[key] != '' ) {
          carry[pre || key] = object[key];
        }

        return carry;
      }, {});
    },
    Vue.prototype.$addObjectToUrl = function(url = '', object, prefix) {
      const flattenParams = this.$objectFlatten(object, prefix)
      const removeParams = [prefix];
      const queryParams = Object.fromEntries( new URLSearchParams( new BX.Uri(url).getQuery() ).entries( ));
      for (const key in queryParams) {
        if (new RegExp(`^${prefix}`).test(key)) {
          removeParams.push(key)
        }
      }
      url = BX.Uri.removeParam(url, removeParams);
      return BX.Uri.addParam(url, flattenParams)
    }
    Vue.prototype.$textToLink = function( text) {

      try {
        let linkReg = /((https?:\/\/[\w\-\.!~?&\=+\*'(),\/\#\:]+)((?!\<\/\w\>))*?)/gm;

        return text.replace(linkReg, '<a href="$1" target="_blank">$1</a>')
      } catch(e){
        return text
      }
    }
  }

};

export {
  useEmptyMount,
  useUtil,
}
